<template>
  <div>
    <Header></Header>


    <div class="box_content">

      <!--公告-->

        <div class="box_content_news">
          <el-card class="box-card">
            <div v-for="o in notice" :key="o" class="textitem" v-if="notice.length != 0">
              <div class="textitem_title" @click="clicknotice(o)">{{o.title}}</div>
              <div class="textitem_time">{{ o.addtime }}</div>
            </div>
            <div v-if="notice.length == 0" class="textitem_title">暂无信息</div>
          </el-card>
        </div>

    </div>

    <!--    通知公告-->
    <el-dialog title="通知公告" :visible.sync="noticestatus" width="60%">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="box_dialog_heng">
            <b>标题：</b>
            <span>{{ noticecontent.title }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="box_dialog_heng">
            <b>时间：</b>
            <span>{{ noticecontent.addtime }}</span>
          </div>
        </el-col>
      </el-row>

      <div class="box_dialog_shu">
        <b>内容</b>
        <span style="text-indent: 2em;line-height: 35px" v-html="noticecontent.content"></span>
      </div>


      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="noticestatus = false">取 消</el-button>-->
        <el-button type="primary" @click="noticestatus = false">确 定</el-button>
      </span>
    </el-dialog>

    <Footer></Footer>
  </div>




</template>

<script>
import Footer from "@/components/footer/index.vue";
import Menulist from "@/components/menulist/index.vue"
import Header from "@/components/heard/index.vue";
import bg from "@/assets/home/kuang_bg.png";
import yidong from "@/assets/home/yidong.png";
import dianxin from "@/assets/home/dianxin.png";
import lianton from "@/assets/home/lianton.png";
import yidongkuang from "@/assets/home/yidong1.png";
import dianxinkuang from "@/assets/home/dianxin3.png";
import liantonkuang from "@/assets/home/liantong2.png";
import Echarts from "@/components/charts/Echarts.vue";
import {
  card_getCardCountByYys,
  card_getTopCards,
  content_contentlist,
  knowledge_queryknowledgelist,
  terminal_getCardCountByStatus,
} from '@/api/manage' // 接口
export default {
  components: { Header, Menulist, Footer, Echarts},
  data() {
    return {
      kuangbg:bg,
      yidonglogo:yidong,
      dianxinlogo:dianxin,
      liantonlogo:lianton,
      yidongkuang:yidongkuang,
      dianxinkuang:dianxinkuang,
      liantonkuang:liantonkuang,
      noticestatus:false,
      noticecontent:'',
      knowledgestatus:false,
      knowledgecontent:'',
      notice:[],
      problem:[],
      option:{},
      options:{},
      dianxininfo:{},
      liantoninfo:{},
      yidonginfo:{},
    }
  },
  created() {
    this.getinfo()
    //   card_getCardCountByYys

  },
  methods: {
    getinfo(){
      card_getCardCountByYys({}).then(response => {
        // console.log(response,'+++++11111111111111')
        if(response.code == 0){
          for(let i=0;i<response.data.length;i++) {
            if (response.data[i].yys == '电信') {
              this.dianxininfo = response.data[i];
            } else if (response.data[i].yys == '联通') {
              this.liantoninfo = response.data[i];
            } else if (response.data[i].yys == '移动') {
              this.yidonginfo = response.data[i];
            }
          }
          // 公告ID：688513922941061
          content_contentlist({page:1,pagesize:5,catid:688513922941061}).then(response => {
            this.notice = response.data.data
          })

          // 知识库ID：688508956799109
          // knowledge_queryknowledgelist({page:1,pagesize:5,catid:696334410236037}).then(response => {
          //   // console.log(response,'+++++')
          //   this.problem = response.data.data
          // })

        }
      })
    },
    clicknotice(row){
      this.noticestatus = true
      this.noticecontent = row
    },
    noticelist(){
      this.$router.push('/noticelist');
    },
    clickknowledge(row){
      this.knowledgestatus = true
      this.knowledgecontent = row
    },
    knowledgelist(){
      this.$router.push('/knowledgelist');
    }

  }
}
</script>

<style lang="scss" scoped>
#app, html ,body{
  height: 100vh;
}

.largeScreen-contents{
  height: 100vh;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed; /* 背景图片固定 */
}

.box_content{
  display: block;
  width: 100%;
  overflow: hidden;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed; /* 背景图片固定 */
  padding-bottom:20px;
  box-sizing: border-box;
}

.box_content_number{
  display: flex;
  flex-direction: row;
  padding: 20px 55px 0;
  box-sizing: border-box;
}

.box_content_chart{
  display: block;
  padding: 20px 55px 0;
  box-sizing: border-box;
}

.box_content_news{
  display: block;
  padding: 20px 55px 0;
  box-sizing: border-box;
}

.clearfix b{
  font-size: 18px;
}

.box_content_number_kuang{
  display: flex;
  flex-direction: row;
  height: 146.5px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.content_number_cont{
  display: flex;
  flex-direction: row;
  padding: 40rpx 50px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}

.number_kuang_logo{
  display: flex;
  flex-direction: column;
  width:20%;
  height: 60px;
  padding: 40px 0;
  line-height: 40px;
  font-weight: bold;
  box-sizing: border-box;
}

.number_kuang_num{
  display: flex;
  flex-direction: column;
  width:30%;
  height: 60px;
  margin: 40px 0;
  position: relative;
}

.num{
  display: block;
  width: 90px;
  height: 56px;
  color: #fff;
  line-height: 56px;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -45px;
}

.numlist{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 60%;
  height: 60px;
  line-height: 30px;
  margin: 40px 0;

}
.numlist_list{
  display: flex;
  flex-direction: row;
  width: 50%;
  height: 30px;
  line-height: 30px;
}

.textitem{
  display: flex;
  flex-direction: row;
  line-height: 35px;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  cursor: pointer;
}

.textitem_title{
  display: block;
  width: 80%;
  height: 35px;
  overflow:hidden; /*超出一行文字自动隐藏*/
  text-overflow:ellipsis;/*文字隐藏后添加省略号*/
  white-space:nowrap;  /*强制不换行*/
}
.textitem_time{
  display: block;
  width: 20%;
  height: 35px;
  text-align: right;
  color: #666;
  overflow:hidden; /*超出一行文字自动隐藏*/
  text-overflow:ellipsis;/*文字隐藏后添加省略号*/
  white-space:nowrap;  /*强制不换行*/
}

.box_dialog_heng{
  display: flex;
  flex-direction: row;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
}

.box_dialog_shu{
  display: flex;
  flex-direction: column;
  line-height: 40px;
}

</style>